import ConfirmationModalBase from 'components/ConfirmationModalBase';
import GlobalSelectors from 'pages/_store/global/selectors';
import { FC, useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

interface Props {
  orderId: string;
}

const BoaRedirection: FC<Props> = ({ orderId }) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const isSuperAdmin = useSelector(GlobalSelectors.getIsSuperAdmin, shallowEqual);

  const handleBoaRedirect = () => {
    window.location.href = `${process.env.REACT_APP_BOA_URL}/orders/${orderId}`;
  };

  const onConfirm = () => {
    setIsConfirmationModalOpen(false);
    handleBoaRedirect();
  };

  useEffect(() => {
    // Super admins can choose to stay while other users are redirected right away
    if (isSuperAdmin) {
      setIsConfirmationModalOpen(true);
    } else {
      handleBoaRedirect();
    }
  }, [orderId]);

  return (
    <ConfirmationModalBase
      isOpen={isConfirmationModalOpen}
      title="Redirection to BOA"
      message="Do you want to proceed to BOA order page?"
      okLabel="Yes, continue"
      closeLabel="No, stay on sales portal"
      onOkay={onConfirm}
      onClose={() => setIsConfirmationModalOpen(false)}
      variant="primary"
    />
  );
};

export default BoaRedirection;
